import type { SerializableRecord } from '../model';
import { isSerializableRecord } from './isSerializableRecord';

export function isRichTextEntryNodeWithoutTarget(
  value: SerializableRecord
): boolean {
  const nodeType = value.nodeType;
  if (
    nodeType !== 'embedded-entry-block' &&
    nodeType !== 'embedded-entry-inline'
  ) {
    return false;
  }

  const data = isSerializableRecord(value.data) ? value.data : undefined;
  return !isSerializableRecord(data?.target);
}
